import { FeatureCollection } from "@turf/turf";
import { memo } from "react";
import styled from "styled-components";
import { Map_ForwardGeocoding_ResponseItem } from "~/common/typescript/apis/MapAPIs";
import MapUtils from "../../utils/MapUtils";

export type AddressItemProps = {
  address: Map_ForwardGeocoding_ResponseItem;
}
const AddressItem = (props: AddressItemProps) => {
  return <UI_AddressItem onClick={() => {
    const location = props.address.geometry.location;
    // window.map?.flyTo({
    //   center: [location.lng, location.lat], // Set the map's center to the address location
    //   zoom: 15, // Adjust the zoom level as needed
    //   essential: true, // Ensures the animation is essential
    // });
    const featureCollection: FeatureCollection = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [location.lng, location.lat],
          },
          properties: {},
        },
      ]
    };
    MapUtils.zoomToFeatureCollection(featureCollection);
  }}>
    <UI_AddressItem_Title>{props.address.formatted_address}</UI_AddressItem_Title>
    <UI_AddressItem_Description>{props.address.compound.commune} {props.address.compound.district} {props.address.compound.province}</UI_AddressItem_Description>
  </UI_AddressItem>
}

export default memo(AddressItem);

const UI_AddressItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
`
const UI_AddressItem_Title = styled.div`
  font-size: 14px;
  padding-bottom: 4px;
`;
const UI_AddressItem_Description = styled.div`
  font-size: 12px;
  color: gray;
`;


